import { initialValuesRole as initialValues } from '../../../../../../helpers/variablesInitialValues';
import * as types from '../types/roleType';

const initialState = {
	perPage: 10,
	page: 1,
	pages: 1,
	search: '',
	arrayList: [],
	arrayListToDropdown: [],
	refreshTable: false,
	isOpenModal: false,
	isOpenModalPermission: false,
	isLoadingShow: false,
	isLoadingForm: false,
	formType: '',
	formData: initialValues
};

const roleReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.PER_PAGE_ROLE:
			return {
				...state,
				perPage: payload
			};
		
		case types.PAGE_ROLE:
			return {
				...state,
				page: payload
			};
		
		case types.PAGES_ROLE:
			return {
				...state,
				pages: payload
			};
		
		case types.SEARCH_ROLE:
			return {
				...state,
				search: payload
			};
		
		case types.ARRAY_LIST_ROLE:
			return {
				...state,
				arrayList: payload
			};
		
		case types.ARRAY_LIST_TO_DROPDOWN_ROLE:
			return {
				...state,
				arrayListToDropdown: payload
			};
		
		case types.REFRESH_TABLE_ROLE:
			return {
				...state,
				refreshTable: payload
			};
		
		case types.IS_OPEN_MODAL_ROLE:
			return {
				...state,
				isOpenModal: payload
			};
			
		case types.IS_OPEN_MODAL_PERMISSION_ROLE:
			return {
				...state,
				isOpenModalPermission: payload
			};
		
		case types.IS_LOADING_SHOW_ROLE:
			return {
				...state,
				isLoadingShow: payload
			};
		
		case types.IS_LOADING_FORM_ROLE:
			return {
				...state,
				isLoadingForm: payload
			};
		
		case types.FORM_TYPE_ROLE:
			return {
				...state,
				formType: payload
			};
		
		case types.FORM_DATA_ROLE:
			return {
				...state,
				formData: payload
			};
		
		default:
			return state
	}
};

export default roleReducer;
